import { trackError } from '@billy/track-error'
import { useMutation } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { getKYCUploadUrl, uploadEInvoicingKYCFile } from '../query-api'

export interface UploadKYCFileResponse {
  fileKey: string
  signature: string
}
interface UploadEInvoiceFileOptions {
  organizationId?: string
  onError?: () => void
}

export const useUploadEInvoiceFile = ({ onError, organizationId }: UploadEInvoiceFileOptions) => {
  const { mutateAsync: getUploadUrl, isLoading: isUploadUrlBeingFetched } = useMutation(
    QueryKeys.EInvoicingGetUploadURL,
    getKYCUploadUrl,
    { onError },
  )

  const {
    mutateAsync: uploadFile,
    isLoading: isFileUploading,
    isSuccess: isUploadSuccessful,
  } = useMutation(QueryKeys.EInvoicingGetUploadURL, uploadEInvoicingKYCFile, {
    onError,
  })

  const isProcessing = isUploadUrlBeingFetched || isFileUploading

  const uploadKycFile = async (file: File): Promise<UploadKYCFileResponse | undefined> => {
    if (!organizationId) {
      trackError('Cannot upload KYC file without organization ID.')
      onError?.()
      return
    }

    const {
      data: { fileKey, signature, signedUrl },
    } = await getUploadUrl({
      network: 'PDP',
      targetId: organizationId,
      filename: file.name,
    })

    await uploadFile({ signedUrl, file })

    return {
      fileKey,
      signature,
    }
  }

  return {
    isProcessing,
    isUploadSuccessful,
    uploadKycFile,
  }
}
